import React, {useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import CellWJTFCs from "./CellWJTFCs";
import WorkerService from "../../../../../../API/orders/job/WorkerService";
import Box from "@mui/material/Box";
import JobService from "../../../../../../API/orders/job/JobService";
import CellCheckboxWithUnable from "../../../../сheckbox/CellCheckboxWithUnable";
import {Checkbox} from "@mui/material";


const WorkerJobTable = ({jobId, setJobData, handleModalAlert}) => {

    const [data, setData] = useState([]);

    useEffect(() => {
        WorkerService.getAllByJobId(jobId).then(function (response) {
            let data = response.data;
            setData(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const handleUnableCheckbox = (id, status) => {
        JobService.unableWorkerByJobsId(jobId, id, status)
            .then(function (response) {
                let data = response.data;
                setJobData(prev => prev.map(el => el.id === data.id ? data : el));
                setData(prev => prev.map(el => el.id === id ? {...el, enabled: status} : el))
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    };


    const columns = useMemo(
        () => [
            {
                header: 'Статус',
                accessorKey: 'enabled',
                size: 8,
                enableEditing: false,
                enableColumnActions: false,
                Cell: ({cell, row}) => <Checkbox
                    onChange={() => handleUnableCheckbox(row.original.id, !row.original.enabled)}
                    checked={row.original.enabled}
                    sx={{'& .MuiSvgIcon-root': {fontSize: 20}}}
                />
            },
            {
                header: 'ФИО',
                accessorKey: 'workerTechnicalMap',
                minSize: 1000,
                enableEditing: false,
                Cell: ({cell}) => <CellWJTFCs cell={cell}></CellWJTFCs>,
            },

            {
                header: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
            },
        ],
        [data, setData],
    );

    return <MaterialReactTable
        renderTopToolbar={({table}) => {
            return <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "7px",
                backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
            }}>
                <MRT_ToolbarAlertBanner table={table}/>
                <Box sx={{display: "flex"}}>
                    <MRT_ToggleFiltersButton table={table}/>
                    <MRT_GlobalFilterTextField table={table}/>
                </Box>
            </Box>
        }}
        selectAllMode={"all"}
        muiTableBodyRowProps={({row}) => {
            return ({
                sx: () => ({
                    height: '36px',
                    backgroundColor: "white",
                    "&:hover& td:after": {
                        display: "none",
                    },
                    "&.MuiTableRow-root.Mui-selected": {
                        backgroundColor: (theme) => theme.palette.primary.light70,
                        "&:hover": {
                            backgroundColor: (theme) => theme.palette.primary.light50,
                        },
                    },
                    "&:hover": {
                        "& td:after": {
                            display: "none",
                        },
                        backgroundColor: (theme) => theme.palette.primary.stroke,
                    },
                    '&:nth-of-type(even)': {
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                        backgroundColor: (theme) => theme.palette.primary.lightGrey,
                        "&:hover": {
                            backgroundColor: (theme) => theme.palette.primary.stroke,
                        },
                    },
                })
            })
        }}
        muiTableHeadCellProps={{
            sx: {
                border: '1px solid #EAEBEA',
                backgroundColor: "#F5F6FA",
                padding: "10px",
                paddingBottom: " 0.2rem",
                paddingTop: "0.2rem"
            },
        }}
        muiTableBodyCellProps={({cell, table}) => {
            return ({
                sx: () => ({
                    p: cell.column.id === "enabled" ? 0 : '0px 0px 0px 10px',
                    textAlign: cell.column.id === "enabled" ? "center" : "left",
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "&:after": {
                        display: "none",
                    },
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                })
            })
        }}
        displayColumnDefOptions={{
            'mrt-row-actions': {
                muiTableHeadCellProps: {
                    align: 'center',
                },
                size: 15,
                minSize: 15,
            },
        }}
        muiSearchTextFieldProps={{
            placeholder: `Поиск`,
            sx: {
                paddingTop: "5px",
                paddingBottom: "0px",
                "& .MuiCollapse-root": {
                    borderRadius: '12px',
                    height: 40, width: 290,
                    "& .MuiSvgIcon-root": {
                        color: "#737478"
                    },
                    '& .MuiOutlinedInput-input': {
                        padding: 0
                    }
                }
            },
            variant: 'outlined',
        }}
        enableToolbarInternalActions={false}
        columns={columns}
        data={data}
        state={{showGlobalFilter: true}}
        rowHeight={13}
        columnSpacing={1}
        initialState={{
            columnVisibility: {
                id: false,
            },
            isFullScreen: false,
            density: "compact",
            pagination: {pageIndex: 0, pageSize: 50},
        }}
        enableEditing={false}
        enableRowSelection={false}
        getRowId={(originalRow) => originalRow.id}
        renderRowActions={({row, table}) => (
            <Box sx={{
                display: 'flex',
                gap: '0.1rem',
                justifyContent: 'flex-start',
                maxWidth: '50px'
            }}>
            </Box>
        )}
        localization={MRT_Localization_RU}
        renderTopToolbarCustomActions={({table}) => {
            const setCurrency = (typeCurrentCurrency) => {
            };

            return (
                <div>
                </div>
            );
        }}
    />;
};

export default WorkerJobTable;